import { Create, translate } from "react-admin";
import React from "react";

import ProjectForm from "./ProjectForm";

const ProjectTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("project.project")}`}</span>;
};

const Title = translate(ProjectTitle);

export const ProjectCreate = props => (
  <Create title={<Title />} {...props}>
    <ProjectForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/project/ProjectCreate.js